import { render } from "./ExpertLoadingDots.vue?vue&type=template&id=b6ab3704&scoped=true"
import script from "./ExpertLoadingDots.vue?vue&type=script&lang=js"
export * from "./ExpertLoadingDots.vue?vue&type=script&lang=js"

import "./ExpertLoadingDots.vue?vue&type=style&index=0&id=b6ab3704&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ab3704"]])

export default __exports__